import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';

interface DataItem {
    name: string;
    parentCategory?: string;
    level: number;
    children?: DataItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TreeMenu',
  props: {
  children: {
    type: Array as PropType<DataItem[]>,
    default: () => ([])
  },
  name: {
    type: String,
    default: ''
  },
  parentCategory: {
    type: String,
    default: ''
  },
  level: {
    type: Number,
    default: 0
  }
},
  emits: ['eventBusAddCat', 'eventBusDelCat'],
  setup(__props, { emit }) {

const { children, name, parentCategory, level } = __props;





const showChildren = ref(false);

function toggleChildren() {
  showChildren.value = !showChildren.value;
}

function eventBusAddCat(event: string) {
  emit('eventBusAddCat', event);
}

function eventBusDelCat(event: string) {
  emit('eventBusDelCat', event);
}

function handleChildrenSelection(checked: boolean, grand: string, parent: string) {
  const allChildren = document.querySelectorAll(`[id^="${grand}_${parent}-"]`);
  allChildren.forEach((el) => {
    const childChecked: boolean = el.getAttribute('aria-checked') === 'true';
    const parentChecked = checked;
    if (parentChecked && !childChecked) {
      (el as HTMLInputElement).click();
    } else if (!parentChecked && childChecked) {
      (el as HTMLInputElement).click();
    }
  });
}

// Clicking on a level 0 checkbox will click on immediate children (level 1)
// this will run handleChildrenSelection and select all level 3 children
function handleAllSelection(checked: boolean, parent: string) {
  children.forEach((child) => {
    const level1 = document.querySelector(`[id="${parent}-${child.name}"]`);
    (level1 as HTMLElement).click();
  });
}

function valueChanged(checked: boolean) {
  if (level === 0) {
    handleAllSelection(checked, parentCategory);
  } else if (level === 1) {
    handleChildrenSelection(checked, parentCategory, name);
  } else if (level === 2 && checked) {
    eventBusAddCat(name);
  } else if (level === 2 && !checked) {
    eventBusDelCat(name);
  }
}


return { __sfc: true,emit, showChildren, toggleChildren, eventBusAddCat, eventBusDelCat, handleChildrenSelection, handleAllSelection, valueChanged }
}

})